import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Container, Row, Col, Card, CardBody, Table } from "reactstrap";
import moment from "moment";

import { withNamespaces } from "react-i18next";

//Import Image
import logo from "../../assets/images/logo-light.png";
import { postSubmitForm } from "../../helpers/forms_helper";
import showNotification from "../../helpers/show_notification";
import { formatUnitsForReport } from "../../helpers/units";
const ReturnInvoice = (props) => {

  const [invoiceData, setData] = useState();
  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const rId = urlParams.get("return_id");
      loadReturnData({ id: rId });
  }, []);

  const loadReturnData = async (data) => {
    let url = process.env.REACT_APP_BASEURL + "itemreturns/get_by_id";
    const response = await postSubmitForm(url, data);
    if (response && response.status === 1) {
      //console.log(response.data);
      setData(response?.data[0]);
    } else {
     showNotification(response.message,"Error")
    }
  };

  // function printInvoice() {
  //   const containerElement = document.getElementsByClassName("page-content")[0];
  //   containerElement.scrollIntoView({ behavior: "smooth", block: "start" });
  //   setTimeout(() => {
  //     window.print();
  //   }, 500);
  // }
  function printInvoice() {
    const containerElement = document.getElementsByClassName("page-content")[0];
    const style = document.createElement("style");
    style.innerHTML = `
      .table thead th {
        background-color: #000 !important; 
        color: #fff !important; 
        -webkit-print-color-adjust: exact; 
      }     
    `;
    document.head.appendChild(style);
    // Scroll to the top of the page content
    containerElement.scrollIntoView({ behavior: "smooth", block: "start" });
  
    setTimeout(() => {
      window.print();
      document.head.removeChild(style);
    }, 500);
  }
  
  const style = {
    top: 0,
    position: "sticky",
  }
  return (
    <React.Fragment>
     <div className="page-content">
        <Container fluid>
          <Row>
            <Col lg="12">
              <Card>
                <CardBody>
                  <div className="d-flex justify-content-between align-items-start mb-4">
                    <div>
                      <img src={logo} alt="logo" height="35" />
                    </div>
                    <div className="text-end">
                      <h3 className="fw-bold">{props.t("RETURN ORDER")}</h3>
                      <p className="mb-1">
                        <strong>{props.t("RO #")}:</strong> {invoiceData?.return_id}
                      </p>
                      <p className="mb-0">
                        <strong>{props.t("Date")}:</strong> {moment(invoiceData?.createdAt).format("DD/MM/YYYY")}
                      </p>
                    </div>
                  </div>

                  <Row className="mb-4">
  <Col md="6" sm="6" lg="6" className="mb-4 mb-md-0">
    <div className="invoice-info-card">
      <h5 className="text-primary border-bottom pb-2 mb-3">
        {props.t("RETURN FROM")}
      </h5>
      <div className="mb-1">
        <span className="text-muted">{props.t("BRANCH NAME")}: </span>
        <strong>{invoiceData?.branch_details?.name}</strong>
      </div>
      <div className="mb-1">
        <span className="text-muted">{props.t("ADDRESS")}: </span>
        <strong>{invoiceData?.branch_details?.address}</strong>
      </div>
      <div className="mb-1">
        <span className="text-muted">{props.t("CONTACT NO")}: </span>
        <strong>{invoiceData?.branch_details?.mobile}</strong>
      </div>
      <div className="mb-1">
        <span className="text-muted">{props.t("EMAIL")}: </span>
        <strong>{invoiceData?.branch_details?.email}</strong>
      </div>
    </div>
  </Col>

  <Col md="6" sm="6" lg="6">
    {invoiceData?.return_to?.supplier ? (
      <div className="invoice-info-card">
        <h5 className="text-primary border-bottom pb-2 mb-3">
          {props.t("RETURN TO SUPPLIER")}
        </h5>
        <div className="mb-1">
          <span className="text-muted">{props.t("VENDOR NAME")}: </span>
          <strong>{invoiceData.return_to.supplier?.name}</strong>
        </div>
        <div className="mb-1">
          <span className="text-muted">{props.t("SALES PERSON")}: </span>
          <strong>{invoiceData.return_to.supplier?.contact_person}</strong>
        </div>
        <div className="mb-1">
          <span className="text-muted">{props.t("ADDRESS")}: </span>
          <strong>{invoiceData.return_to.supplier?.address}</strong>
        </div>
        <div className="mb-1">
          <span className="text-muted">{props.t("CONTACT NO")}: </span>
          <strong>{invoiceData.return_to.supplier?.mobile}</strong>
        </div>
        <div className="mb-1">
          <span className="text-muted">{props.t("EMAIL")}: </span>
          <strong>{invoiceData.return_to.supplier?.email}</strong>
        </div>
      </div>
    ) : (
      <div className="invoice-info-card">
        <h5 className="text-primary border-bottom pb-2 mb-3">
          {props.t("RETURN TO CENTRAL STORE")}
        </h5>
        <div className="mb-1">
                          <span className="text-muted">{props.t("CUSTOMER NAME")}: </span>
                          <strong>KARAK MQANES</strong>
                        </div>
                        <div className="mb-1">
                          <span className="text-muted">{props.t("PURCHASE MANAGER")}: </span>
                          <strong>MR MOIN MUNAWER</strong>
                        </div>
                        <div className="mb-1">
                          <span className="text-muted">{props.t("ADDRESS")}: </span>
                          <strong>
                            GWC Bu Fesseela Warehousing Park,
                            VA 8-5 (A) OPP TO EMDADCO FOOD STUFF
                          </strong>
                        </div>
                        <div className="mb-1">
                          <span className="text-muted">{props.t("CONTACT NO")}: </span>
                          <strong>77234663</strong>
                        </div>
                        <div className="mb-1">
                          <span className="text-muted">{props.t("EMAIL")}: </span>
                          <strong>purchase@karakmqanes.com</strong>
                        </div>
                      </div>
    )}
  </Col>
</Row>

                  {invoiceData?.items && invoiceData.items.length > 0 && (
                    <>
                      <div className="py-2 mt-3">
                        <h3 className="font-size-15 font-weight-bold">
                          {props.t("Items")}
                        </h3>
                      </div>
                      <div className="table-responsive">
                        <Table className="table-nowrap">
                          <thead style={style}>
                            <tr>
                              <th>{props.t("Name")}</th>
                              <th>{props.t("Category")}</th>
                              <th>{props.t("Sub-Category")}</th>
                              <th>{props.t("Inventory Batch No.")}</th>
                              <th className="text-right">{props.t("Price")}</th>
                              <th className="text-right">{props.t("Quantity")}</th>
                              <th className="text-right">{props.t("Total Price")}</th>
                            </tr>
                          </thead>
                          <tbody>
                            {invoiceData.items.map((item, key) => (
                              <tr key={key}>
                                <td>{item.name}</td>
                                <td>{item.category}</td>
                                <td>{item.sub_category}</td>
                                <td>{item.batch}</td>
                                <td className="text-right">{item.cost_price}/{item.unit_for_po}</td>
                                <td className="text-right">
                                  {formatUnitsForReport(item.quantity)}
                                </td>
                                <td className="text-right">
                                  {item.total_price.toFixed(2)}
                                </td>
                              </tr>
                            ))}
                            <tr>
                              <td colSpan="6" className="border-0 text-right">
                                <strong>{props.t("Total")}</strong>
                              </td>
                              <td className="border-0 text-right">
                                <strong>
                                  {invoiceData.items.reduce(
                                    (acc, item) => acc + +item.total_price,
                                    0
                                  ).toFixed(2)}
                                </strong>
                              </td>
                            </tr>
                          </tbody>
                        </Table>
                      </div>
                    </>
                  )}

                  <hr />
                  <Table className="table-nowrap">
                    <tbody>
                      <tr>
                        <td className="border-0">
                          <strong>{props.t("Additional Note")}</strong>
                        </td>
                        <td className="border-0 text-right">
                          <strong>{props.t("AUTHORIZE BY")}</strong>
                        </td>
                      </tr>
                      <tr>
                        <td className="border-0">
                          {invoiceData?.remarks || props.t("No additional notes")}
                        </td>
                        <td className="border-0 text-right"></td>
                      </tr>
                    </tbody>
                  </Table>

                  <div className="d-print-none">
                    <div className="float-right">
                      <Link
                        to="#"
                        onClick={printInvoice}
                        className="btn btn-success waves-effect waves-light mr-2"
                      >
                        <i className="fa fa-print"></i> {props.t("Print")}
                      </Link>
                    </div>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default withNamespaces()(ReturnInvoice);
